<div class="row wow animate__fadeInUp" id="bg"  data-wow-delay="200ms">
  <div class="col-md-12">
    <div class="get-started-box">
      <h3>Get Started Today</h3>
      <p>With 3,000 Free Email Validations*</p>
      <button class="get-started-btn" routerLink="/register">
        TRY IT FREE
      </button>
    </div>
  </div>
</div>
